import localFont from "next/font/local";

const notoSansSC = localFont({
  src: [
    { path: "./NotoSansSC-400.woff2", weight: "400", style: "normal" },
    { path: "./NotoSansSC-500.woff2", weight: "500", style: "normal" },
    { path: "./NotoSansSC-700.woff2", weight: "700", style: "normal" },
  ],
  variable: "--font-noto-sans-sc",
  display: "swap",
});

const notoSerifSC = localFont({
  src: [
    { path: "./NotoSerifSC-400.woff2", weight: "400", style: "normal" },
    { path: "./NotoSerifSC-500.woff2", weight: "500", style: "normal" },
    { path: "./NotoSerifSC-700.woff2", weight: "700", style: "normal" },
  ],
  variable: "--font-noto-serif-sc",
  display: "swap",
});

const zcoolXiaoWei = localFont({
  src: [{ path: "./ZCOOLXiaoWei-Regular.ttf", weight: "400", style: "normal" }],
  variable: "--font-zcool-xiaowei",
  display: "swap",
});

type FontEntry = {
  label: string;
  font: { variable: string } | null;
};

export const fontRegistry = {
  system: { label: "主题默认", font: null },
  notoSansSC: { label: "思源黑体", font: notoSansSC },
  notoSerifSC: { label: "思源宋体", font: notoSerifSC },
  zcoolXiaoWei: { label: "站酷小薇", font: zcoolXiaoWei },
} as const satisfies Record<string, FontEntry>;

export type FontKey = keyof typeof fontRegistry;

export const fontVars = (Object.values(fontRegistry) as Array<FontEntry>)
  .map((f) => f.font?.variable || "")
  .filter(Boolean)
  .join(" ");

export const fontOptions = (
  Object.entries(fontRegistry) as Array<[FontKey, FontEntry]>
).map(([key, f]) => ({ key, label: f.label, variable: f.font?.variable || "" }));
